import React from 'react';
import { Box } from '@mui/material';
import { COVER_IMAGE_SQUARE_WIDTH } from '../eventFormConstants';

const frameSx = {
  width: COVER_IMAGE_SQUARE_WIDTH,
  maxWidth: COVER_IMAGE_SQUARE_WIDTH,
  aspectRatio: '1 / 1',
  borderRadius: 2,
  overflow: 'hidden',
  position: 'relative',
  bgcolor: 'grey.100',
};

const imageSx = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  position: 'absolute',
  inset: 0,
};

const CoverImagePreview = ({ src, alt = 'Event cover image' }) => {
  if (!src) return null;

  return (
    <Box sx={frameSx}>
      <Box component="img" src={src} alt={alt} sx={imageSx} />
    </Box>
  );
};

export default CoverImagePreview;
